import PageWrapper from 'components/utils/PageWrapper';
import PowerBiReports from 'pages/PowerBiReports';

export const powerBIRoutes = {
    path: '/power_bi_reports/:workspaceId',
    element: (
        <PageWrapper titleId="power_bi_reports">
            <PowerBiReports />
        </PageWrapper>
    ),
};
